/*
  Fixed header that shrinks on scroll. Used by the main header and the
  locked page header (anything marked data-zp-header). The header gets a
  data-compact attribute; each header's own CSS decides what shrinks.

  It also gets --zp-scroll-y (how far the page has scrolled, capped). The
  header CSS uses it so the header is never shorter than the part of its
  spacer still on screen. Without that, scrolling back to the top quickly
  shows an empty strip under the header while it grows back.
*/
(() => {
  const headers = document.querySelectorAll('[data-zp-header]');
  if (!headers.length) return;

  // Shrink once the page scrolls down a bit; grow back near the top.
  // The gap between the two numbers stops it flickering at the edge.
  let compact = false;
  let lastLift = -1;
  let ticking = false;
  const update = () => {
    const y = window.scrollY;
    if (!compact && y > 60) compact = true;
    else if (compact && y < 10) compact = false;
    // Past 400px the value no longer matters, so stop updating it.
    const lift = Math.round(Math.min(Math.max(y, 0), 400));
    headers.forEach((header) => {
      // Pinned headers (product pages, RDCTD) stay shrunk all the time.
      header.toggleAttribute('data-compact', compact || header.hasAttribute('data-zp-header-pinned'));
      if (lift !== lastLift) header.style.setProperty('--zp-scroll-y', `${lift}px`);
    });
    lastLift = lift;
    ticking = false;
  };
  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  update();

  // Remember the last products page or product the visitor looked at (this tab only),
  // so the ← on REDACTED, CONTACT and the cart can take them back to their shopping.
  const strip = (url) => url.split('#')[0];
  const isShopPage = /^\/(collections\/[^/]|products\/)/.test(window.location.pathname);
  const rememberShop = () => {
    try {
      if (isShopPage) sessionStorage.setItem('zp-last-shop', strip(window.location.href));
    } catch (error) {}
  };
  rememberShop();
  // Again on the way out, in case the address changed (a product page adds ?variant= when a size is picked).
  window.addEventListener('pagehide', rememberShop);

  // The ← in the subheader.
  // - data-zp-back="history" (product pages): if the visitor came from another page of
  //   this store, go back one step, so they land at the exact spot they were scrolled to,
  //   with the same category and zoom.
  // - data-zp-back="shop" (REDACTED, CONTACT, cart): back to the last products page or
  //   product. If that's the page they just came from, step back (keeps the scroll spot);
  //   otherwise open it.
  // With nothing to go back to, the link itself goes to the products.
  document.addEventListener('click', (event) => {
    const back = event.target.closest('[data-zp-back]');
    if (!back || event.metaKey || event.ctrlKey || event.shiftKey) return;
    let cameFromHere = false;
    try {
      cameFromHere = document.referrer !== '' && new URL(document.referrer).origin === window.location.origin;
    } catch (error) {}
    if (back.dataset.zpBack === 'shop') {
      let lastShop = null;
      try {
        lastShop = sessionStorage.getItem('zp-last-shop');
      } catch (error) {}
      if (!lastShop) return;
      event.preventDefault();
      if (cameFromHere && strip(document.referrer) === lastShop && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = lastShop;
      }
      return;
    }
    if (cameFromHere && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });
})();
